/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from 'react'
import { Column, Stack, Label, Button } from 'trux'
import { Icon } from 'trux/dist/atoms'
import { Color } from 'trux/dist/atoms/Color'
import image from './no-sensor-box.svg'

const SensorlessResultsContent = ({ title, ...props }) => {
    return (
        <Column {...props} center>
            <img src={image} alt="No Tracers" width="123px" />
            <Label margin="4 0 6 0" type={Label.Type.Heading4} bold center>
                {title}
            </Label>
            <Button
                marginBottom="8"
                href="https://traceup.com/soccer/help/sensorless-game-results"
                target="_blank"
                primary
                content={(
                    <>
                        Learn more
                        &nbsp;
                        <Icon type={Icon.Type.Leave} color={Color.TraceTint2} />
                    </>
                )}
            />
        </Column>
    )
}

SensorlessResultsContent.defaultProps = {
    title: 'Not enough Tracers to identify players ☹️'
}

export { SensorlessResultsContent }

